import styled from "@emotion/styled";
import { Flexbox } from "../../core/components";
import { LensIcon } from "../../common/components";

export const StyledLensIcon = styled(LensIcon)`
    :not(:first-of-type) {
        margin-left: -34px;
    }
`;
export const GroupInfoContainer = styled(Flexbox)`
    overflow: hidden;
    margin-left: 10px;
`;
